export const SET_REFETCH_REVENUE_REPORTS_LIST = "SET_REFETCH_REVENUE_REPORTS_LIST";

export const TOGGLE_REVENUE_REPORT_DRAWER = "TOGGLE_REVENUE_REPORT_DRAWER";
